<template>
  <div>
    <v-row dense>
      <v-col cols="12" md="6">
        <v-list dense>
          <v-list-item two-line>
            <v-list-item-icon><v-icon>mdi-car</v-icon></v-list-item-icon>
            <v-list-item-content>
              <v-list-item-subtitle>Vehicle No.</v-list-item-subtitle>
              <v-list-item-title class="font-weight-medium">
                {{ casefile.vehicleNo?.toUpperCase() }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item two-line>
            <v-list-item-icon><v-icon>mdi-file-document</v-icon></v-list-item-icon>
            <v-list-item-content>
              <v-list-item-subtitle>Our Ref.</v-list-item-subtitle>
              <v-list-item-title class="font-weight-medium">
                AA/{{ filterDept(casefile.refType)[0]?.name || "" }}{{ filterSubDept(casefile.subRefType)[0] ? "/" + filterSubDept(casefile.subRefType)[0].subCode : "" }}/{{ casefile.id }}/{{ yearOnly(casefile.createdAt) }}{{ filterBranches(casefile.branch)[0]?.brCode ? "/" + filterBranches(casefile.branch)[0].brCode : "" }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item two-line>
            <v-list-item-icon><v-icon>mdi-calendar</v-icon></v-list-item-icon>
            <v-list-item-content>
              <v-list-item-subtitle>Date of Loss</v-list-item-subtitle>
              <v-list-item-title class="font-weight-medium">
                {{ formatDate(casefile.dateOfLoss) }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item two-line>
            <v-list-item-icon><v-icon>mdi-map-marker</v-icon></v-list-item-icon>
            <v-list-item-content>
              <v-list-item-subtitle>Place of Loss</v-list-item-subtitle>
              <v-list-item-title class="font-weight-medium">
                {{ casefile.placeOfLoss }}, {{ filterStates(casefile.stateOfLoss)[0]?.name }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-col>

      <v-col cols="12" md="6">
        <v-list dense>
          <v-list-item two-line>
            <v-list-item-icon><v-icon>mdi-file-document-outline</v-icon></v-list-item-icon>
            <v-list-item-content>
              <v-list-item-subtitle>Claim Type</v-list-item-subtitle>
              <v-list-item-title class="font-weight-medium">
                {{ filterDept(casefile.refType)[0]?.name || "N/A" }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item two-line>
            <v-list-item-icon><v-icon>mdi-calendar-check</v-icon></v-list-item-icon>
            <v-list-item-content>
              <v-list-item-subtitle>Assignment Date</v-list-item-subtitle>
              <v-list-item-title class="font-weight-medium">
                {{ formatDate(casefile.dateOfAssign) }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item two-line>
            <v-list-item-icon><v-icon>mdi-calendar-clock</v-icon></v-list-item-icon>
            <v-list-item-content>
              <v-list-item-subtitle>Acknowledgement Date</v-list-item-subtitle>
              <v-list-item-title class="font-weight-medium">
                {{ formatDate(casefile.createdAt) }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item two-line>
            <v-list-item-icon><v-icon>mdi-account</v-icon></v-list-item-icon>
            <v-list-item-content>
              <v-list-item-subtitle>Case Creator</v-list-item-subtitle>
              <v-list-item-title class="font-weight-medium">
                {{ filterUser(casefile.createdBy)[0]?.username || "N/A" }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item two-line>
            <v-list-item-icon><v-icon>mdi-domain</v-icon></v-list-item-icon>
            <v-list-item-content>
              <v-list-item-subtitle>Creator Branch</v-list-item-subtitle>
              <v-list-item-title class="font-weight-medium">
                <span v-for="creator in filterUser(casefile.createdBy)" :key="creator.id">
                  <span v-for="(b, index) in creator.branches" :key="index">{{ b.name }}</span>
                </span>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import moment from "moment";
export default {
  name: "CaseInformationBody",
  props: ["casefile", "branches", "refType", "subRefTypes", "states" , "members"],
  methods: {
    formatDate(d) { return d ? moment(d).format('DD/MM/YYYY') : ''; },
    filterDept(item) { return (this.refType || []).filter(dept => dept.id === item); },
    filterSubDept(item) { return (this.subRefTypes || []).filter(s => s.id === item); },
    filterBranches(item) { return (this.branches || []).filter(b => b.id === item); },
    filterStates(item) { return (this.states || []).filter(s => s.id === item); },
    filterUser(item) { return (this.members || []).filter(m => m.id === item); },
    yearOnly(v) { return v ? moment(v).format('YY') : ''; }
  }
}
</script>
